<div class="divHome">
  <div style="padding-bottom: 2rem">
      <h2>Proveedores</h2>
  </div>
  <hr style="margin-bottom: 2rem">

  <div *ngIf="loading" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <div *ngIf="!loading" style="display: flex; justify-content: center;">
    <mat-form-field appearance="outline" class="buttonFilter">
      <mat-label>TIPO DE PROVEEDOR</mat-label>
      <mat-select [(value)]="selectTipoProveedor" (selectionChange)="applyFilterSelect()">
        <mat-option value={{null}}>No seleccionar</mat-option>
        <mat-option *ngFor="let tipoProveedor of arrayTipoProveedor" value={{tipoProveedor}}>{{tipoProveedor}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="divInputSearch" style="width: 70%">
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda" />
    </mat-form-field>

  </div>

  <div [style.display]="loading ? 'none' : 'block'" class="example-container mat-elevation-z8 overflow"  *ngIf="DataSource">
    <mat-table    [dataSource]="DataSource" matSort >

      <mat-header-row *matHeaderRowDef="DisplayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: DisplayedColumns"></mat-row>

      <ng-container matColumnDef="numRUC">
          <mat-header-cell *matHeaderCellDef>N° RUC</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.numRUC }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nombre">
        <mat-header-cell *matHeaderCellDef>NOMBRE</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.nombre }}</mat-cell>
    </ng-container>

      <ng-container matColumnDef="codigo">
          <mat-header-cell *matHeaderCellDef>CODIGO</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.cuentaCorrienteDolares ? getCodigo(element.cuentaCorrienteDolares) : 'no existe'  }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="tipoProveedor">
        <mat-header-cell *matHeaderCellDef>TIPO</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.tipoProveedor }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>Seleccionar</mat-header-cell>
      <mat-cell *matCellDef="let element; let i=index">
        <button mat-icon-button (click)="goBack(element)"><mat-icon class="icon-color">
          send</mat-icon></button>
      </mat-cell>
  </ng-container>

    </mat-table>
  </div>
  <div [hidden]="loading">
    <mat-paginator style="width: 100%" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>
  </div>


</div>

